// extracted by mini-css-extract-plugin
export default {"SortingPyramid":"SortingPyramid_SortingPyramid__c3A+x","active":"SortingPyramid_active__SFEF6","reverse":"SortingPyramid_reverse__GzU7B"};